<template>
  <EditComponent v-bind:kimono="kimono"   v-bind:obi="obi"  v-bind:obijime="obijime">
  <template v-slot:header>
  Obijime Name
  </template>
  <table style="width:50%">
   <tr>
     <td><b>Typ</b></td>
     <td>Obijime aus Mijajime</td>
   </tr>
   <tr>
     <td><b>Farbe</b></td>
     <td>Blau</td>
   </tr>
  </table>
</EditComponent>
</template>

<script>
import EditComponent from '../components/EditComponent.vue'


export default {
  name: 'Obijime',
  components: {
    EditComponent
  },
  props: {
    kimono: String,
    obi: String,
    obijime: String,
    showbutton: Boolean
  }
}
</script>
